<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{pageTitle}}</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">          
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="20" v-model="func.functionCode" class="form-control" autocomplete="off" :placeholder="[[functionDisplayHolder]]" required>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>機能ポリシー</label>
              </div>
              <div class="col-9">
                <textarea id="limited" v-model="func.functionPolicy" class="textarea" rows="3" cols="60"></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
              </div>
              <div class="col-9">
                <label v-if="isFunctionPolicyJson" style="color:green;">Valid JSON</label>
                <label v-else style="color:red;">Invalid JSON</label>
              </div>
            </div>
          </div>

          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      message: '',
      func: {
        functionCode: '',
        functionPolicy: ''
      }
    }
  },
  computed: {
    isSuper: function () {
      return Number(this.$store.state.user.privilege) === authority.isSuper
    },
    isMessage: function () {
      return this.message.length > 0
    },
    pageTitle: function (){
      return '機能新規登録'
    },    
    functionDisplayHolder:function (){
      return '機能名（必須）'
    },
    isFunctionPolicyJson: function(){
      if (this.func.functionPolicy == '') return true;
      try{
        JSON.parse(this.func.functionPolicy);
      }
      catch (e){
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(!session){
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)

          if (!this.isFunctionPolicyJson){
            this.message = "機能ポリシーはJSON形ではありません。"
            return;
          }
          else{
            this.message = "";
          }

          axios.post("/api/function/", {
            functionCode: this.func.functionCode,
            functionPolicy: this.func.functionPolicy
          },{
            headers: this.headers(accessToken)
          }).then((response) => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/function/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch(err => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/function/index'))
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>